import DecisionTree from '@Components/DecisionTree';
import { FullPage } from '@Utils/styles';
import React from 'react';

const AGSet = () => {
	return (
		<FullPage>
			<DecisionTree />
		</FullPage>
	);
};
export default AGSet;
